import PersonBasicInfo from './PersonBasicInfo';

export default PersonBasicInfo;
